import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { EVENT_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IEventGroupCategory } from '~/Models/DTO/EventGroupCategory.model';

export const useRequestCategoryList = () => {
  const { currentProvider } = useProvider();

  return useQuery<IEventGroupCategory[], IErrorResponse>(
    [REQUEST_ACTIONS.EVENTCATEGORIES, currentProvider?.uuid],
    () =>
      requestReactQuery<IEventGroupCategory[]>({
        url: EVENT_SERVICE_URLS.SPORT_CATEGORY_TYPES,
        config: { method: 'GET' },
        params: {
          ProviderId: currentProvider?.uuid,
        },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: true,
      initialData: [],
      enabled: !!currentProvider?.uuid,
    },
  );
};
